import { render, staticRenderFns } from "./relatorioSimuladorExterno.vue?vue&type=template&id=54b4b5df"
import script from "./relatorioSimuladorExterno.vue?vue&type=script&lang=js"
export * from "./relatorioSimuladorExterno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports